import React, { FC } from 'react';
import {
  useClearRefinements,
  useCurrentRefinements,
  useRange,
  useRefinementList,
} from 'react-instantsearch';
import { css } from '@emotion/core';

import { Box, colors, Divider, Icon, Text } from '../../../design-system';
import { getRefinementLabel } from '../utils';
import { formatPriceStore } from './Refinements';

type Props = {
  attribute: string;
  index: number;
  title: string;
  onClick: () => void;
};

export const MobileFilterSelector: FC<Props> = ({ attribute, index, title, onClick }) => {
  const { items } = useCurrentRefinements({ includedAttributes: [attribute] });
  const { refine, canRefine } = useClearRefinements({ includedAttributes: [attribute] });
  const { items: refinementItems } = useRefinementList({
    attribute: attribute === 'storePrice' ? '_' : attribute,
  });
  const { range } = useRange({ attribute: 'storePrice' });

  return (
    <Box
      display={
        (attribute === 'storePrice' && range.min === range.max) ||
        (!refinementItems.length && attribute !== 'storePrice')
          ? 'none'
          : 'block'
      }
    >
      <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        position="relative"
        py="xs"
      >
        {canRefine && (
          <button
            data-testid={`Button for clear filters`}
            aria-label={`Bouton pour effacer les filtres`}
            type="button"
            css={css`
              display: flex;
              align-items: center;
              justify-content: center;
              min-width: 44px;
              height: 44px;
              border: none;
              padding: 0;
              margin-right: 8px;
              background: unset;
              cursor: pointer;
              color: ${colors.BLACK};
            `}
            onClick={refine}
          >
            <Icon name="delete" size={14} id={`filter-bar-clear-filters-${index}`} />
          </button>
        )}
        <button
          type="button"
          onClick={onClick}
          data-testid={`Button for access the ${title} filters`}
          aria-label={`Bouton pour accéder aux filtres ${title}`}
          css={css`
            display: flex;
            height: 44px;
            width: 100%;
            align-items: center;
            justify-content: space-between;
            border: none;
            background: unset;
            padding: 0;
            cursor: pointer;
          `}
        >
          <Text textTransform="uppercase" id={`filter-bar-filter-title-${index}`}>
            {title}
          </Text>
          <Box display="flex" alignItems="center">
            <Box maxWidth="160px" mx="s">
              <Text
                withEllipsis
                preset="caption"
                color="GREY"
                id={`filter-bar-selected-filters-${index}`}
              >
                {items.map((item) => {
                  return item.attribute === 'storePrice'
                    ? formatPriceStore(item.refinements, range)
                    : item.refinements.map((ref) => getRefinementLabel(ref.label)).join(', ');
                })}
              </Text>
            </Box>
            <Icon name="chevronRight" size={14} />
          </Box>
        </button>
      </Box>
      <Divider />
    </Box>
  );
};
